import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = ['id', 'email', 'context', 'updated_at'];

export const getEsignFlow = asyncThunkWrapper({ 
  model: 'esignFlow', 
  action: 'getEsignFlow', 
  func: async () => {
    const params = { attributes };
    const response = await axios.get(`/esign_flow`, { params });

    return response.data;
  } 
});
export const createEsignFlow = asyncThunkWrapper({ 
  model: 'esignFlow', 
  action: 'createEsignFlow', 
  func: async (esign_flow) => {
    const response = await axios.post(`/esign_flow`, { esign_flow, attributes });

    return response.data;
  } 
});
export const updateEsignFlow = asyncThunkWrapper({ 
  model: 'esignFlow', 
  action: 'updateEsignFlow', 
  func: async (esign_flow) => {
    const response = await axios.patch(`/esign_flow`, { esign_flow });

    return { status: response.status, esign_flow };
  } 
});
export const deleteEsignFlow = asyncThunkWrapper({ 
  model: 'esignFlow', 
  action: 'deleteEsignFlow', 
  func: async () => {
    const response = await axios.delete(`/esign_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveEsignFlow = createAction('esignFlow/clearLocalActiveEsignFlow');